import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { Router } from '@angular/router';
import { SDKVersion, SDKVersionService } from '@app/core';
import { SDKVersionSearchParam } from '@app/core/models/sdk-version-search-param.model';
import { AlloxCommonAsyncPipe, IAlloxAsyncPipeIDValueList, IAlloxAsyncPipeOption } from './allox-common-async.pipe';

interface ISDKVersionPipeOption extends IAlloxAsyncPipeOption {
  value?: boolean;
}
@Pipe({
    name: 'sdkVersion', pure: false,
    standalone: false
})
export class SDKVersionPipe
  extends AlloxCommonAsyncPipe<SDKVersion>
  implements IAlloxAsyncPipeIDValueList<SDKVersion>, PipeTransform {

  constructor(private service: SDKVersionService, changeDetectorRef: ChangeDetectorRef, router: Router) {
    super(changeDetectorRef, router);
  }

  loadDependency() {
    return this.service.search(new SDKVersionSearchParam());
  }

  makeText(value: number, obj: SDKVersion, option?: ISDKVersionPipeOption) {
    if (!obj) {
      return `Unknown [id: ${value}]`;
    }
    return obj.value;
  }

}
